import {
  type CheckboxV2Props,
  Checkbox as GfiberCheckbox,
} from '@pixel-party/Checkbox/v2';

import {forwardRef} from 'react';

export const Checkbox = forwardRef<HTMLButtonElement, CheckboxV2Props>(
  (props, ref) => (
    <GfiberCheckbox
      {...props}
      ref={ref}
    />
  ),
);

Checkbox.displayName = 'Checkbox';
